import { AuthStepItemView } from '../../../../stepRenderer';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function AuthStepItemsList({
  items,
  params,
  onParamChange
}) {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: items.map(stepItem => /*#__PURE__*/_jsx(AuthStepItemView, {
      item: stepItem.item,
      label: stepItem.label,
      params: params,
      onChange: onParamChange
    }, stepItem.label))
  });
}